<template>
  <div>
    <nav class="navbar   is-fixed-top " :class="background_colour" role="navigation" aria-label="main navigation">
  <div class="navbar-brand  ">
    <a href="/" class="navbar-item mr-6" >
      <img :src="navbar_logo" />
    </a>

    <a href="/bookings/new#pending"><button class="button is-danger m-1" v-if="app_replies.length > 0">{{ app_replies.length }} App Replies</button></a>
    


  </div>
  <div class="buttons  navbar-end">
    <button class="button  m-1 " :class="{'is-danger' : this.newNotesToView ==true, 'is-light' : this.newNotesToView ==false}" style="display:none" @click="openNotesModal()">Notes</button>
    <a href="/on-call" style="display:none"><button class="button is-info m-1 mr-4">On Call</button></a>  
    <a href="/members"><button class="button is-success m-1">Members</button></a>
      <a href="/bookings/new"><button class="button is-warning m-1">Bookings</button></a>
      <a href="/applications/dashboard-new"><button class="button is-light m-1">Applications</button></a>
      
    </div>



 
</nav>


<div class="modal" :class="{'is-active' : this.showNotesModal == true}">
      <div class="modal-background" @click="showNotesModal = false"></div>
      <div class="modal-content">
        <div class="box content">
          <button class="button is-success">Add a New Note</button><br /><br />
          <blockquote><strong>Added by Ciara</strong><br />First note here<br/>Second line</blockquote>
          <blockquote>First note here<br/>Second line
            <br /> <button class="button is-small is-danger ">Delete For All</button>
          </blockquote>
          <blockquote><strong>Added by David</strong><br />First note here<br/>Second line</blockquote>
          <blockquote>
            <strong>Added by Kieran</strong><br />Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec hendrerit orci a ante elementum varius. Nunc cursus pellentesque nisi id laoreet. Ut efficitur est felis, et aliquet diam viverra in. In suscipit elit ex, in auctor magna dapibus eget. Pellentesque tempus magna eu ipsum volutpat vestibulum. Vestibulum viverra placerat nisl, ac blandit libero maximus sit amet. Nunc a mi sem. Duis congue vulputate nisl, sit amet placerat nulla bibendum at. <br />Duis dignissim aliquam nisl sed commodo. Vestibulum maximus justo non mi dapibus tincidunt quis ac magna. Etiam nec ipsum sed leo hendrerit cursus.<br/>Second line
           <br /> <button class="button is-small is-danger ">Delete For All</button>
          </blockquote>
          
        </div>
        
      </div>
      <button class="modal-close is-large" aria-label="close" @click="showNotesModal = false"></button>
    </div>

</div>

</template>

<script>
import UtilityService from '@/services/UtilityService.js';

export default {
  name: 'NavBar',
  components: {
    
  },
  data: function () {
        return {
                API_NAME: process.env.VUE_APP_API_NAME,
                background_colour: process.env.VUE_APP_NAVBAR_COLOUR,
                accessToken: '',
                user: [],
                loading: true,
                app_replies: 0,
                showNotesModal: false,
                newNotesToView: false,
                navbar_logo: process.env.VUE_APP_NAVBAR_LOGO,
               
        }
    },
  methods: {
          logout() {
              if(confirm('Are you sure you want to logout ?'))
              {
                  this.$auth.logout({
                  returnTo: window.location.origin
                });
              }
      },
      openNotesModal() {
        this.showNotesModal = true
        this.newNotesToView = false
      },
      async getAppReplies() {
          

          UtilityService.getSimpleApiData(this.accessToken, "member_alerts?interested=1&assigned=0")
                .then(
                    (app_replies => {
                        this.$set(this, "app_replies", app_replies);
                        
                    }).bind(this)
                );
          
      },
      async checkNotes() {
        this.newNotesToView = Math.random() < 0.5;
      }
    },
    mounted() {
          this.getAccessToken()
            .then(() => { 
                this.getAppReplies()
                //this.getNotes()

                setInterval(() => {
                  this.getAppReplies()
                }, 90000);

                //setInterval(() => {
                //  this.checkNotes()
                //}, 10000);
            });
          
        },
}
</script>